module.exports = __webpack_public_path__ + "static/media/446.798ee54b.webp";